// This file is generated by scripts/permissions/generate-permission-actions.mjs.
// Do not edit manually. Update scripts/permissions/config/permission-actions.json and run pnpm permissions:generate-actions.

import permissionSeedConfig from '../../../scripts/permissions/config/permission-actions.json'

export const PermissionActions = Object.freeze({
  AdminAccess: 'Admin.Access',
  AdminOsiAccess: 'Admin.OsiAccess',
  TenantBrandingView: 'TenantBranding.View',
  DashboardView: 'Dashboard.View',
  DashboardHeaderUpdate: 'Dashboard.Header.Update',
  PeopleView: 'People.View',
  PeopleCreate: 'People.Create',
  PeopleUpdate: 'People.Update',
  PeopleDelete: 'People.Delete',
  EventsView: 'Events.View',
  EventsCreate: 'Events.Create',
  EventsUpdate: 'Events.Update',
  EventsHolidayProgrammeView: 'Events.HolidayProgramme.View',
  EventsClassAttendanceView: 'Events.ClassAttendance.View',
  EventsCommitteeMeetingsView: 'Events.CommitteeMeetings.View',
  MailerView: 'Mailer.View',
  MailerCreate: 'Mailer.Create',
  MailerUpdate: 'Mailer.Update',
  MailerDelete: 'Mailer.Delete',
  MailerDuplicate: 'Mailer.Duplicate',
  MailerArchive: 'Mailer.Archive',
  MailerUnarchive: 'Mailer.Unarchive',
  MailerSend: 'Mailer.Send',
  MailerSchedule: 'Mailer.Schedule',
  MailerDraftsView: 'Mailer.Drafts.View',
  MailerHistoryView: 'Mailer.History.View',
  MailerMailingListsView: 'Mailer.MailingLists.View',
  MailerMailingListsCreate: 'Mailer.MailingLists.Create',
  MailerMailingListsUpdate: 'Mailer.MailingLists.Update',
  MailerMailingListsDelete: 'Mailer.MailingLists.Delete',
  MailerRecipientsManage: 'Mailer.Recipients.Manage',
  MailerAttachmentsUpload: 'Mailer.Attachments.Upload',
  MailerMobileCreate: 'Mailer.Mobile.Create',
  MailerMobileUpdate: 'Mailer.Mobile.Update',
  MailerTemplateSettingsView: 'Mailer.TemplateSettings.View',
  MailerTemplateSettingsUpdate: 'Mailer.TemplateSettings.Update',
  MailerTemplateAccessManage: 'Mailer.TemplateAccess.Manage',
  MailerSharedTemplatesManage: 'Mailer.SharedTemplates.Manage',
  MailerOsiView: 'Mailer.Osi.View',
  MailerOsiMigrate: 'Mailer.Osi.Migrate',
  MailerSystemEmailsView: 'Mailer.SystemEmails.View',
  NoticesView: 'Notices.View',
  NoticesCreate: 'Notices.Create',
  NoticesSend: 'Notices.Send',
  NoticesUpdate: 'Notices.Update',
  NoticesDelete: 'Notices.Delete',
  NoticesHistoryView: 'Notices.History.View',
  NoticesSetupView: 'Notices.Setup.View',
  NoticesSetupUpdate: 'Notices.Setup.Update',
  NoticesRecipientsSearch: 'Notices.Recipients.Search',
  NoticesAttachmentsUpload: 'Notices.Attachments.Upload',
  TrackingView: 'Tracking.View',
  TrackingUpdate: 'Tracking.Update',
  TrackingExport: 'Tracking.Export',
  TrackingHubsView: 'Tracking.Hubs.View',
  TrackingHubsCreate: 'Tracking.Hubs.Create',
  TrackingHubsUpdate: 'Tracking.Hubs.Update',
  TrackingHubsDelete: 'Tracking.Hubs.Delete',
  TrackingHubsReorder: 'Tracking.Hubs.Reorder',
  TrackingCategoriesManage: 'Tracking.Categories.Manage',
  TrackingSportTypesManage: 'Tracking.SportTypes.Manage',
  TrackingRatingsManage: 'Tracking.Ratings.Manage',
  TrackingAssigneesManage: 'Tracking.Assignees.Manage',
  TrackingPromoteView: 'Tracking.Promote.View',
  TrackingRecordsView: 'Tracking.Records.View',
  TrackingRecordsCreate: 'Tracking.Records.Create',
  TrackingRecordsUpdate: 'Tracking.Records.Update',
  TrackingRecordsDelete: 'Tracking.Records.Delete',
  TrackingReportsView: 'Tracking.Reports.View',
  TrackingSpringBoardView: 'Tracking.SpringBoard.View',
  TrackingReportsExport: 'Tracking.Reports.Export',
  TrackingReportsOrganizationView: 'Tracking.Reports.Organization.View',
  TrackingCertificatesView: 'Tracking.Certificates.View',
  TrackingCertificatesUpdate: 'Tracking.Certificates.Update',
  SitesView: 'Sites.View',
  SitesCreate: 'Sites.Create',
  SitesUpdate: 'Sites.Update',
  SitesDelete: 'Sites.Delete',
  SitesPublish: 'Sites.Publish',
  SitesSettingsView: 'Sites.Settings.View',
  SitesSettingsUpdate: 'Sites.Settings.Update',
  SitesPagesUpdate: 'Sites.Pages.Update',
  SitesSitemapUpdate: 'Sites.Sitemap.Update',
  SitesAccessView: 'Sites.Access.View',
  SitesAccessAssign: 'Sites.Access.Assign',
  SitesAccessRemove: 'Sites.Access.Remove',
  SitesVersionsView: 'Sites.Versions.View',
  CodesView: 'Codes.View',
  GroupsView: 'Groups.View',
  TermsView: 'Terms.View',
  TermGroupsView: 'TermGroups.View',
  MobileAppView: 'MobileApp.View',
  MobileAppUpdate: 'MobileApp.Update',
  MobileAppDelete: 'MobileApp.Delete',
  MobileAppSetupView: 'MobileApp.Setup.View',
  MobileAppSetupCreate: 'MobileApp.Setup.Create',
  MobileAppSetupUpdate: 'MobileApp.Setup.Update',
  MobileAppContactsManage: 'MobileApp.Contacts.Manage',
  MobileAppGroupsView: 'MobileApp.Groups.View',
  MobileAppGroupsUpdate: 'MobileApp.Groups.Update',
  MobileAppGoLive: 'MobileApp.GoLive',
  MobileAppStatusUpdate: 'MobileApp.Status.Update',
  MobileAppUsersReportView: 'MobileApp.UsersReport.View',
  MobileAppChatReportsView: 'MobileApp.ChatReports.View',
  MobileAppChatReportsHide: 'MobileApp.ChatReports.Hide',
  SettingsView: 'Settings.View',
  SettingsMainView: 'Settings.Main.View',
  SettingsMainUpdate: 'Settings.Main.Update',
  RolesView: 'Roles.View',
  RolesManage: 'Roles.Manage',
  RolesCreate: 'Roles.Create',
  RolesUpdate: 'Roles.Update',
  RolesDelete: 'Roles.Delete',
  RolesAssignEndpoint: 'Roles.AssignEndpoint',
  RolesAssignUser: 'Roles.AssignUser',
  RoleGroupsView: 'RoleGroups.View',
  RoleGroupsCreate: 'RoleGroups.Create',
  RoleGroupsUpdate: 'RoleGroups.Update',
  RoleGroupsDelete: 'RoleGroups.Delete',
  RoleGroupsAssignRole: 'RoleGroups.AssignRole',
  ProfileRoleGroupsAssign: 'ProfileRoleGroups.Assign',
  ProfileRoleGroupsDelete: 'ProfileRoleGroups.Delete',
  FieldsView: 'Fields.View',
  FieldsCreate: 'Fields.Create',
  FieldsUpdate: 'Fields.Update',
  FieldsDelete: 'Fields.Delete',
  FieldsExtraDataEntry: 'Fields.ExtraData.Entry',
  FieldsExtraDataBulkEntry: 'Fields.ExtraData.BulkEntry',
  SegmentsView: 'Segments.View',
  SegmentsCreate: 'Segments.Create',
  SegmentsUpdate: 'Segments.Update',
  SegmentsDelete: 'Segments.Delete',
  SegmentBlocksView: 'SegmentBlocks.View',
  SegmentBlocksCreate: 'SegmentBlocks.Create',
  SegmentBlocksUpdate: 'SegmentBlocks.Update',
  SegmentBlocksDelete: 'SegmentBlocks.Delete',
  TemplatesView: 'Templates.View',
  TemplatesCreate: 'Templates.Create',
  TemplatesUpdate: 'Templates.Update',
  TemplatesDelete: 'Templates.Delete',
  MembershipsView: 'Memberships.View',
  MembershipsCreate: 'Memberships.Create',
  MembershipsUpdate: 'Memberships.Update',
  MembershipsDelete: 'Memberships.Delete',
  MembershipDetailsView: 'MembershipDetails.View',
  MembershipDetailsCreate: 'MembershipDetails.Create',
  MembershipDetailsUpdate: 'MembershipDetails.Update',
  MembershipDetailsDelete: 'MembershipDetails.Delete',
  BaseFeesView: 'BaseFees.View',
  BaseFeesCreate: 'BaseFees.Create',
  BaseFeesUpdate: 'BaseFees.Update',
  BaseFeesDelete: 'BaseFees.Delete',
  MemberTypeBaseFeesView: 'MemberTypeBaseFees.View',
  MemberTypeBaseFeesCreate: 'MemberTypeBaseFees.Create',
  MemberTypeBaseFeesUpdate: 'MemberTypeBaseFees.Update',
  MemberTypeBaseFeesDelete: 'MemberTypeBaseFees.Delete',
  RegistrationFormsView: 'RegistrationForms.View',
  RegistrationFormsCreate: 'RegistrationForms.Create',
  RegistrationFormsUpdate: 'RegistrationForms.Update',
  RegistrationFormsRoleGroupsView: 'RegistrationForms.RoleGroups.View',
  PersonTypesView: 'PersonTypes.View',
  PersonTypesCreate: 'PersonTypes.Create',
  PersonTypesUpdate: 'PersonTypes.Update',
  PersonTypesDelete: 'PersonTypes.Delete',
  PersonTypeOrganisationDisciplinesView: 'PersonTypeOrganisationDisciplines.View',
  PersonTypeOrganisationDisciplinesCreate: 'PersonTypeOrganisationDisciplines.Create',
  PersonTypeOrganisationDisciplinesUpdate: 'PersonTypeOrganisationDisciplines.Update',
  PersonTypeOrganisationDisciplinesDelete: 'PersonTypeOrganisationDisciplines.Delete',
  MembershipCategoriesView: 'MembershipCategories.View',
  MembershipCategoriesCreate: 'MembershipCategories.Create',
  MembershipCategoriesUpdate: 'MembershipCategories.Update',
  MembershipCategoriesDelete: 'MembershipCategories.Delete',
  OrganisationDisciplinesView: 'OrganisationDisciplines.View',
  OrganisationDisciplinesCreate: 'OrganisationDisciplines.Create',
  OrganisationDisciplinesUpdate: 'OrganisationDisciplines.Update',
  OrganisationDisciplinesDelete: 'OrganisationDisciplines.Delete',
  ProfileOrganisationRolesView: 'ProfileOrganisationRoles.View',
  ProfileOrganisationRolesCreate: 'ProfileOrganisationRoles.Create',
  ProfileOrganisationRolesUpdate: 'ProfileOrganisationRoles.Update',
  ProfileOrganisationRolesDelete: 'ProfileOrganisationRoles.Delete',
  TermsAndConditionsView: 'TermsAndConditions.View',
  TermsAndConditionsCreate: 'TermsAndConditions.Create',
  TermsAndConditionsUpdate: 'TermsAndConditions.Update',
  TermsAndConditionsDelete: 'TermsAndConditions.Delete',
  TerminologyView: 'Terminology.View',
  TerminologyCreate: 'Terminology.Create',
  TerminologyUpdate: 'Terminology.Update',
  TerminologyDelete: 'Terminology.Delete',
  SuperAdminLimitedClubsView: 'SuperAdminLimited.Clubs.View',
  SuperAdminLimitedClubsUpdate: 'SuperAdminLimited.Clubs.Update',
  SuperAdminLimitedClubsFinalizeRegistration: 'SuperAdminLimited.Clubs.FinalizeRegistration',
  SuperAdminLimitedClubsConvertToOrganization: 'SuperAdminLimited.Clubs.ConvertToOrganization',
  SuperAdminLimitedClubsImpersonate: 'SuperAdminLimited.Clubs.Impersonate',
  SuperAdminLimitedClubsMainView: 'SuperAdminLimited.Clubs.Main.View',
  SuperAdminLimitedClubsMainUpdate: 'SuperAdminLimited.Clubs.Main.Update',
  SuperAdminLimitedClubsContactView: 'SuperAdminLimited.Clubs.Contact.View',
  SuperAdminLimitedClubsContactUpdate: 'SuperAdminLimited.Clubs.Contact.Update',
  SuperAdminLimitedClubsTerminologyView: 'SuperAdminLimited.Clubs.Terminology.View',
  SuperAdminLimitedClubsTerminologyUpdate: 'SuperAdminLimited.Clubs.Terminology.Update',
  SuperAdminLimitedClubsOsiModulesView: 'SuperAdminLimited.Clubs.OsiModules.View',
  SuperAdminLimitedClubsOsiModulesAdd: 'SuperAdminLimited.Clubs.OsiModules.Add',
  SuperAdminLimitedClubsOsiModulesRemove: 'SuperAdminLimited.Clubs.OsiModules.Remove',
  SuperAdminLimitedClubsPeopleView: 'SuperAdminLimited.Clubs.People.View',
  SuperAdminLimitedClubsPeopleCreate: 'SuperAdminLimited.Clubs.People.Create',
  SuperAdminLimitedClubsPeopleUpdate: 'SuperAdminLimited.Clubs.People.Update',
  SuperAdminLimitedClubsPeopleDelete: 'SuperAdminLimited.Clubs.People.Delete',
  SuperAdminLimitedClubsSportTypesView: 'SuperAdminLimited.Clubs.SportTypes.View',
  SuperAdminLimitedClubsSportTypesAdd: 'SuperAdminLimited.Clubs.SportTypes.Add',
  SuperAdminLimitedClubsSportTypesRemove: 'SuperAdminLimited.Clubs.SportTypes.Remove',
  SuperAdminLimitedClubsCodesView: 'SuperAdminLimited.Clubs.Codes.View',
  SuperAdminLimitedClubsGroupsView: 'SuperAdminLimited.Clubs.Groups.View',
  SuperAdminLimitedClubsTermsView: 'SuperAdminLimited.Clubs.Terms.View',
  SuperAdminLimitedClubsTermGroupsView: 'SuperAdminLimited.Clubs.TermGroups.View',
  SuperAdminLimitedClubsTermGroupsMembersView: 'SuperAdminLimited.Clubs.TermGroups.Members.View',
  SuperAdminLimitedClubsManageClubsView: 'SuperAdminLimited.Clubs.ManageClubs.View',
  SuperAdminLimitedClubsManageClubsAdd: 'SuperAdminLimited.Clubs.ManageClubs.Add',
  SuperAdminLimitedClubsManageClubsRemove: 'SuperAdminLimited.Clubs.ManageClubs.Remove',
  SuperAdminLimitedDashboardView: 'SuperAdminLimited.Dashboard.View',
  SuperAdminLimitedPeopleView: 'SuperAdminLimited.People.View',
  SuperAdminLimitedPeopleUpdate: 'SuperAdminLimited.People.Update',
  SuperAdminLimitedPeopleDelete: 'SuperAdminLimited.People.Delete',
  SuperAdminLimitedPeopleTenantsView: 'SuperAdminLimited.People.Tenants.View',
  SuperAdminLimitedPeopleTenantsAssign: 'SuperAdminLimited.People.Tenants.Assign',
  SuperAdminLimitedPeopleTenantsRemove: 'SuperAdminLimited.People.Tenants.Remove',
  SuperAdminUsersView: 'SuperAdmin.Users.View',
  SuperAdminUsersCreate: 'SuperAdmin.Users.Create',
  SuperAdminUsersUpdate: 'SuperAdmin.Users.Update',
  SuperAdminUsersTenantsView: 'SuperAdmin.Users.Tenants.View',
  SuperAdminUsersTenantsAssign: 'SuperAdmin.Users.Tenants.Assign',
  SuperAdminUsersTenantsUpdate: 'SuperAdmin.Users.Tenants.Update',
  SuperAdminUsersTenantsRemove: 'SuperAdmin.Users.Tenants.Remove',
  SuperAdminLimitedProfileView: 'SuperAdminLimited.Profile.View',
  SuperAdminLimitedProfileSocialConnectUpdate: 'SuperAdminLimited.Profile.SocialConnect.Update',
  SuperAdminLimitedProfileDebugView: 'SuperAdminLimited.Profile.Debug.View',
  SuperAdminLimitedProfileChangePassword: 'SuperAdminLimited.Profile.ChangePassword',
  SuperAdminLimitedRolesView: 'SuperAdminLimited.Roles.View',
  SuperAdminLimitedRolesCreate: 'SuperAdminLimited.Roles.Create',
  SuperAdminLimitedRolesUpdate: 'SuperAdminLimited.Roles.Update',
  SuperAdminLimitedRolesDelete: 'SuperAdminLimited.Roles.Delete',
  SuperAdminLimitedRolesEndpointsView: 'SuperAdminLimited.Roles.Endpoints.View',
  SuperAdminLimitedRolesEndpointsAdd: 'SuperAdminLimited.Roles.Endpoints.Add',
  SuperAdminLimitedRolesEndpointsRemove: 'SuperAdminLimited.Roles.Endpoints.Remove',
  SuperAdminLimitedRolesExport: 'SuperAdminLimited.Roles.Export',
  SuperAdminLimitedRolesImport: 'SuperAdminLimited.Roles.Import',
  SuperAdminLimitedRoleGroupsView: 'SuperAdminLimited.RoleGroups.View',
  SuperAdminLimitedRoleGroupsCreate: 'SuperAdminLimited.RoleGroups.Create',
  SuperAdminLimitedRoleGroupsUpdate: 'SuperAdminLimited.RoleGroups.Update',
  SuperAdminLimitedRoleGroupsDelete: 'SuperAdminLimited.RoleGroups.Delete',
  SuperAdminLimitedRoleGroupsRolesView: 'SuperAdminLimited.RoleGroups.Roles.View',
  SuperAdminLimitedRoleGroupsRolesAdd: 'SuperAdminLimited.RoleGroups.Roles.Add',
  SuperAdminLimitedRoleGroupsRolesRemove: 'SuperAdminLimited.RoleGroups.Roles.Remove',
  SuperAdminLimitedMasterBrandsView: 'SuperAdminLimited.Master.Brands.View',
  SuperAdminLimitedMasterBrandsCreate: 'SuperAdminLimited.Master.Brands.Create',
  SuperAdminLimitedMasterBrandsUpdate: 'SuperAdminLimited.Master.Brands.Update',
  SuperAdminLimitedMasterBrandsDelete: 'SuperAdminLimited.Master.Brands.Delete',
  SuperAdminLimitedMasterBrandsLogoUpload: 'SuperAdminLimited.Master.Brands.Logo.Upload',
  SuperAdminLimitedMasterComponentsView: 'SuperAdminLimited.Master.Components.View',
  SuperAdminLimitedMasterComponentsCreate: 'SuperAdminLimited.Master.Components.Create',
  SuperAdminLimitedMasterComponentsUpdate: 'SuperAdminLimited.Master.Components.Update',
  SuperAdminLimitedMasterComponentsDelete: 'SuperAdminLimited.Master.Components.Delete',
  SuperAdminLimitedMasterComponentsLogoUpload: 'SuperAdminLimited.Master.Components.Logo.Upload',
  SuperAdminLimitedMasterComponentsBrandAssignmentsView:
    'SuperAdminLimited.Master.Components.BrandAssignments.View',
  SuperAdminLimitedMasterComponentsBrandAssignmentsAdd:
    'SuperAdminLimited.Master.Components.BrandAssignments.Add',
  SuperAdminLimitedMasterComponentsBrandAssignmentsDelete:
    'SuperAdminLimited.Master.Components.BrandAssignments.Delete',
  SuperAdminLimitedMasterCountriesView: 'SuperAdminLimited.Master.Countries.View',
  SuperAdminLimitedMasterCountriesCreate: 'SuperAdminLimited.Master.Countries.Create',
  SuperAdminLimitedMasterCountriesUpdate: 'SuperAdminLimited.Master.Countries.Update',
  SuperAdminLimitedMasterCountriesDelete: 'SuperAdminLimited.Master.Countries.Delete',
  SuperAdminLimitedMasterSportCategoriesView: 'SuperAdminLimited.Master.SportCategories.View',
  SuperAdminLimitedMasterSportCategoriesCreate: 'SuperAdminLimited.Master.SportCategories.Create',
  SuperAdminLimitedMasterSportCategoriesUpdate: 'SuperAdminLimited.Master.SportCategories.Update',
  SuperAdminLimitedMasterSportCategoriesDelete: 'SuperAdminLimited.Master.SportCategories.Delete',
  SuperAdminLimitedMasterTenantDefinitionsView: 'SuperAdminLimited.Master.TenantDefinitions.View',
  SuperAdminLimitedMasterTenantDefinitionsCreate:
    'SuperAdminLimited.Master.TenantDefinitions.Create',
  SuperAdminLimitedMasterTenantDefinitionsUpdate:
    'SuperAdminLimited.Master.TenantDefinitions.Update',
  SuperAdminLimitedMasterTenantDefinitionsDelete:
    'SuperAdminLimited.Master.TenantDefinitions.Delete',
  SuperAdminLimitedMasterTenantDefinitionsLogoUpload:
    'SuperAdminLimited.Master.TenantDefinitions.Logo.Upload',
  SuperAdminLimitedMasterTenantDefinitionsComponentsView:
    'SuperAdminLimited.Master.TenantDefinitions.Components.View',
  SuperAdminLimitedMasterTenantDefinitionsComponentsAdd:
    'SuperAdminLimited.Master.TenantDefinitions.Components.Add',
  SuperAdminLimitedMasterTenantDefinitionsComponentsUpdate:
    'SuperAdminLimited.Master.TenantDefinitions.Components.Update',
  SuperAdminLimitedMasterTenantDefinitionsComponentsDelete:
    'SuperAdminLimited.Master.TenantDefinitions.Components.Delete',
  SuperAdminLimitedMasterTerminologiesView: 'SuperAdminLimited.Master.Terminologies.View',
  SuperAdminLimitedMasterTerminologiesCreate: 'SuperAdminLimited.Master.Terminologies.Create',
  SuperAdminLimitedMasterTerminologiesUpdate: 'SuperAdminLimited.Master.Terminologies.Update',
  SuperAdminLimitedMasterTerminologiesDelete: 'SuperAdminLimited.Master.Terminologies.Delete',
  SuperAdminLimitedMasterProfileOrganizationRolesView:
    'SuperAdminLimited.Master.ProfileOrganizationRoles.View',
  SuperAdminLimitedMasterProfileOrganizationRolesCreate:
    'SuperAdminLimited.Master.ProfileOrganizationRoles.Create',
  SuperAdminLimitedMasterProfileOrganizationRolesUpdate:
    'SuperAdminLimited.Master.ProfileOrganizationRoles.Update',
  SuperAdminLimitedMasterProfileOrganizationRolesDelete:
    'SuperAdminLimited.Master.ProfileOrganizationRoles.Delete',
  SuperAdminLimitedMasterSportTypesView: 'SuperAdminLimited.Master.SportTypes.View',
  SuperAdminLimitedMasterSportTypesCreate: 'SuperAdminLimited.Master.SportTypes.Create',
  SuperAdminLimitedMasterSportTypesUpdate: 'SuperAdminLimited.Master.SportTypes.Update',
  SuperAdminLimitedMasterSportTypesDelete: 'SuperAdminLimited.Master.SportTypes.Delete',
  SuperAdminLimitedMasterOsiAccessModulesView: 'SuperAdminLimited.Master.OsiAccessModules.View',
  SuperAdminLimitedMasterOsiAccessModulesCreate: 'SuperAdminLimited.Master.OsiAccessModules.Create',
  SuperAdminLimitedMasterOsiAccessModulesUpdate: 'SuperAdminLimited.Master.OsiAccessModules.Update',
  SuperAdminLimitedMasterOsiAccessModulesDelete: 'SuperAdminLimited.Master.OsiAccessModules.Delete',
  SuperAdminLimitedGlobalSiteThemesView: 'SuperAdminLimited.GlobalSiteThemes.View',
  SuperAdminLimitedGlobalSiteThemesCreate: 'SuperAdminLimited.GlobalSiteThemes.Create',
  SuperAdminLimitedGlobalSiteThemesUpdate: 'SuperAdminLimited.GlobalSiteThemes.Update',
  SuperAdminLimitedGlobalSiteThemesDelete: 'SuperAdminLimited.GlobalSiteThemes.Delete',
  SuperAdminLimitedGlobalSiteThemesDuplicate: 'SuperAdminLimited.GlobalSiteThemes.Duplicate',
  SuperAdminLimitedGlobalSiteThemesImport: 'SuperAdminLimited.GlobalSiteThemes.Import',
  SuperAdminLimitedGlobalSiteThemesMetadataUpdate:
    'SuperAdminLimited.GlobalSiteThemes.Metadata.Update',
  SuperAdminLimitedGlobalSiteThemesBuilderView: 'SuperAdminLimited.GlobalSiteThemes.Builder.View',
  SuperAdminLimitedGlobalSiteThemesBuilderUpdate:
    'SuperAdminLimited.GlobalSiteThemes.Builder.Update',
  SuperAdminLimitedGlobalSiteThemesSitemapView: 'SuperAdminLimited.GlobalSiteThemes.Sitemap.View',
  SuperAdminLimitedGlobalSiteThemesSitemapUpdate:
    'SuperAdminLimited.GlobalSiteThemes.Sitemap.Update',
  SuperAdminLimitedGlobalSiteThemesPagesView: 'SuperAdminLimited.GlobalSiteThemes.Pages.View',
  SuperAdminLimitedGlobalSiteThemesPagesCreate: 'SuperAdminLimited.GlobalSiteThemes.Pages.Create',
  SuperAdminLimitedGlobalSiteThemesPagesUpdate: 'SuperAdminLimited.GlobalSiteThemes.Pages.Update',
  SuperAdminLimitedGlobalSiteThemesPagesDelete: 'SuperAdminLimited.GlobalSiteThemes.Pages.Delete',
  SuperAdminLimitedGlobalSiteThemesPageBuilderView:
    'SuperAdminLimited.GlobalSiteThemes.PageBuilder.View',
  SuperAdminLimitedGlobalSiteThemesPageBuilderUpdate:
    'SuperAdminLimited.GlobalSiteThemes.PageBuilder.Update',
  SuperAdminLimitedLogsMobileProfileListView: 'SuperAdminLimited.Logs.MobileProfileList.View',
  SuperAdminLimitedLogsMobileProfileListDelete: 'SuperAdminLimited.Logs.MobileProfileList.Delete',
  SuperAdminLimitedLogsMobileProfileListImpersonate:
    'SuperAdminLimited.Logs.MobileProfileList.Impersonate',
  SuperAdminLimitedLogsMobileTenantListView: 'SuperAdminLimited.Logs.MobileTenantList.View',
  SuperAdminLimitedLogsMobileTenantListImpersonate:
    'SuperAdminLimited.Logs.MobileTenantList.Impersonate',
  SuperAdminLimitedLogsNotificationsView: 'SuperAdminLimited.Logs.Notifications.View',
  SuperAdminLimitedLogsStartChatRecordsView: 'SuperAdminLimited.Logs.StartChatRecords.View',
  SuperAdminLimitedLogsChatRecordsView: 'SuperAdminLimited.Logs.ChatRecords.View',
  SuperAdminLimitedLogsErrorLogsView: 'SuperAdminLimited.Logs.ErrorLogs.View',
  SuperAdminLimitedLogsAuditView: 'SuperAdminLimited.Logs.Audit.View',
  SuperAdminLimitedOASystemTable: 'SuperAdminLimited.OASystem.Table',
  SuperAdminLimitedOASystemDetail: 'SuperAdminLimited.OASystem.Detail',
  SuperAdminClubsCreate: 'SuperAdmin.Clubs.Create',
})

function actionToKey(action) {
  return action
    .split('.')
    .filter(Boolean)
    .map(part => part.replace(/[^a-zA-Z0-9]/g, ''))
    .join('')
}

export const permissionActionDefinitions = permissionSeedConfig.actions.map(actionConfig => ({
  ...actionConfig,
  key: actionToKey(actionConfig.action),
}))

export const permissionActionRegistry = Object.freeze(
  permissionActionDefinitions.reduce((acc, actionConfig) => {
    acc[actionConfig.action] = actionConfig
    return acc
  }, {}),
)

export function isKnownPermissionAction(action) {
  return Boolean(permissionActionRegistry[action])
}
